define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function PasswordVmModule(aoflModules) {
  'use strict';
  var storeService = aoflModules.store;

  var passwordModalVmService = function passwordModalVmService(
    riqUserModelService,
    riqGroupModelService,
    $rootScope,
    $state
  ) {
    var closeModal = function closeModal() {
      storeService.commit([
        {
          stateAlias: 'passwordModal',
          mutationId: 'error',
          payload: 0
        },
        {
          stateAlias: 'riqModals',
          mutationId: 'hide',
          payload: {}
        }
      ]);
    };

    var checkGotoMarketing = function checkGotoMarketing() {
      var state = storeService.getState();
      var gotoMarketing = state.passwordModal.gotoMarketing;
      if (gotoMarketing) {
        storeService.commit([
          {
            stateAlias: 'passwordModal',
            mutationId: 'update',
            payload: {
              gotoMarketing: false
            }
          }
        ]);
        window.location = '/subscription/teacher';
        return;
      }
    };

    var continueToNextState = function continueToNextState(nextState) {
      checkGotoMarketing();
      var name = nextState && nextState.name ? nextState.name : 'my_shelf_en';
      var params = nextState && nextState.params ? nextState.params : {};

      /*
      (daniel.mendoza) INFOSEC-470: Prevent student profiles to bypassing the password prompt.
       The main issue is that the profile gets switched before password gets
      validated. It would require a bigger lift for that change.
      (daniel.mendoza) TODO: Change the order profile switching and password validation.
      */
      if (localStorage.getItem('riqClassLoginLock')) {
        localStorage.removeItem('riqClassLoginLock');
      }

      return $state.go(name, params);
    };

    var checkPassword = function checkPassword(password, nextState) {
      return riqUserModelService
        .checkPassword(password)
        .then(function() {
          closeModal();
          localStorage.setItem('lastPasswordEntered', Date.now());
          var state = storeService.getState();
          var profile =
            state.group && state.group.profiles
              ? riqGroupModelService.getGroupOwner(state.group.profiles)
              : {};
          var commits = [
            {
              stateAlias: 'user',
              mutationId: 'update',
              payload: {authenticated: true}
            },
            {
              stateAlias: 'passwordModal',
              mutationId: 'error',
              payload: 0
            }
          ];
          if (profile && profile.profileUuid) {
            commits.unshift({
              stateAlias: 'profile',
              mutationId: 'setUserProfile',
              payload: profile
            });
          }
          storeService.commit(commits);
          continueToNextState(nextState);
        })
        .catch(function() {
          closeModal();
          storeService.commit([
            {
              stateAlias: 'user',
              mutationId: 'update',
              payload: {authenticated: false}
            },
            {
              stateAlias: 'passwordModal',
              mutationId: 'error',
              payload: 'wrongPassword'
            },
            {
              stateAlias: 'riqModals',
              mutationId: 'show',
              payload: 'passwordModal'
            }
          ]);
        });
    };

    return {
      closeModal: closeModal,
      checkPassword: checkPassword,
      continueToNextState: continueToNextState
    };
  };

  return passwordModalVmService;
});
